export default __webpack_public_path__ + "static/media/investors_logo6.1af4c8c0.png";